import './style.css'
import './components/MemeGrid.js'

// Environment variables
const PUMPFUN = import.meta.env.VITE_PUMPFUN === 'TRUE';
const CONTRACT_ADDRESS = 'CyaKU5xf7KYorAQsM6Gr6TTaYSN9pojwUMh8QQAXpump';

// Add random rotation to elements
function addRandomRotation() {
  const elements = document.querySelectorAll('.tokenomics-card, .step-card');
  elements.forEach(el => {
    const rotation = Math.random() * 4 - 2; // Random rotation between -2 and 2 degrees
    el.style.transform = `rotate(${rotation}deg)`;
  });
}

// Add bounce effect to emoji
function addEmojiAnimation() {
  const emojis = document.querySelectorAll('.tokenomics-icon');
  emojis.forEach(emoji => {
    emoji.addEventListener('mouseover', () => {
      emoji.style.transform = 'scale(1.2) rotate(10deg)';
    });
    emoji.addEventListener('mouseout', () => {
      emoji.style.transform = 'scale(1) rotate(0deg)';
    });
  });
}

document.querySelector('#app').innerHTML = `
  <nav class="nav-bar" id="stickyNav">
    <div class="nav-content">
      <div class="nav-logo">$SOLENSKEE</div>
      <div class="nav-social">
        <a href="https://x.com/solenskee" target="_blank" class="social-icon" title="Follow us on Twitter">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
          </svg>
        </a>
        <a href="https://t.me/solenskee" target="_blank" class="social-icon" title="Join our Telegram">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z"/>
          </svg>
        </a>
      </div>
    </div>
  </nav>

  <header class="header">
    <img src="/assets/banner2.jpg" alt="Banner" class="banner-image">
  </header>

  <div class="contract-address">
    <div class="ca-label">CA:</div>
    <div class="ca-value" id="contractAddress">${CONTRACT_ADDRESS}</div>
    <button class="copy-btn" onclick="copyContractAddress()">COPY</button>
  </div>

  <div class="ticker-container">
    <div class="ticker-content">
      <div class="ticker-item">$SOLENSKEE</div>
      <div class="ticker-item">$SOLENSKEE</div>
      <div class="ticker-item">$SOLENSKEE</div>
      <div class="ticker-item">$SOLENSKEE</div>
      <div class="ticker-item">$SOLENSKEE</div>
      <div class="ticker-item">$SOLENSKEE</div>
    </div>
  </div>

  <section class="hero">
    <img src="/assets/american-flag.jpg" alt="American Flag Background" class="flag-background">
    <div class="container hero-content">
      <div class="breaking-news">
        <h2 class="news-title">🔥 BREAKING: SOLENSKEE vs. TREMP SHOWDOWN IN SOLANA! 🔥</h2>
        <div class="news-content">
          <p>Doland Tremp n Volodoomyr Solenskee just had a furious clash in Ze White House of Soluna, turning a minerals deal into a meme war!</p>
          
          <p class="quote">💥 Tremp told Solenskee: "Make a deal with ze Ber or we are out!"</p>
          <p class="quote">💥 Solenskee: "No comproomises! No rug! No capitulation!"</p>
          
          <p>Tremp accused Solenskee of being unthankful for all ze Solana airdrops n said he was "gambling with World War Three (of memecoins)." Ze meeting escalated fast, n Solenskee left before ze deal could be signed! 🚗💨</p>
          
          <div class="social-posts">
            <div class="tremp-post">
              <p>🔴 Tremp posted on Trooth Soshial:</p>
              <p class="post-content">"Solenskee disrespected ze sacred Oval Office of Solana. He iz not ready for PEACE, only PUMP."</p>
            </div>
            
            <div class="solenskee-post">
              <p>🔵 Solenskee posted on X:</p>
              <p class="post-content">"Thank you, thank you, thank you, thank you Solana for support."</p>
            </div>
          </div>
          
          <p>Now, ze Ber n ze Bull are divided. Russia supports Tremp, Macron supports Solenskee, Poland says "You are not alone!"</p>
          
          <p class="final-call">💰 $SOLENSKEE iz ze coomunity taekover of ze TRUE fighter! No compromise, no rug, only PUMP! Buy $SOLENSKEE n secure ze future of Soluna! 🚀🔥</p>
        </div>
      </div>

    </div>
  </section>

  <section class="how-to-buy">

    <div class="container">
      <h2 class="buy-title">HOW TO BUY</h2>
      <div class="steps-container">
        <div class="step-card">
          <div class="step-number">1</div>
          <h3 class="step-title">CREATE A<br/>WALLET</h3>
          <p class="step-description">DOWNLOAD PHANTOM OR YOUR WALLET OF CHOICE FROM THE APP STORE OR WEB. FOR DESKTOP USERS, DOWNLOAD YOUR BROWSER'S EXTENSION.</p>
          <a href="https://phantom.app" target="_blank" class="btn btn-dark">PHANTOM</a>
        </div>
        <div class="step-card">
          <div class="step-number">2</div>
          <h3 class="step-title">GET SOME<br/>$SOL</h3>
          <p class="step-description">HAVE $SOL IN YOUR WALLET TO SWITCH TO $SOLENSKEE. IF YOU DON'T HAVE ANY $SOL YOU CAN BUY DIRECTLY ON PHANTOM, TRANSFER FROM ANOTHER WALLET, OR BUY ON ANOTHER EXCHANGE AND SEND IT TO YOUR WALLET.</p>
          <a href="https://phantom.com/learn/guides/how-to-buy-ethereum-eth-polygon-matic-and-solana-sol" target="_blank" class="btn btn-dark">SEE GUIDE</a>
        </div>
        <div class="step-card">
          <div class="step-number">3</div>
          <h3 class="step-title">GO TO<br/>DEXSCREENER</h3>
          <p class="step-description">CONNECT YOUR WALLET, PASTE THE $SOLENSKEE TOKEN ADDRESS, SELECT $SOLENSKEE, AND CONFIRM. WHEN YOU GET A PROMPT FOR A WALLET SIGNATURE, SIGN.</p>
          <a href="#" class="btn btn-dark" id="buyNowBtn">TRADE NOW</a>
        </div>
        <div class="step-card blue-card">
          <div class="step-title-large">$SOLENSKEE ✓</div>
          <p class="step-description-light">PARTICIPATE IN THE $SOLENSKEE COMMUNITY, SHARE MEMES, TALK TO OTHER HOLDERS AND PARTICIPATE IN COMMUNITY EVENTS</p>
        </div>
      </div>
    </div>
  </section>





  <div class="flag-ticker">
    <div class="flag-content">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <!-- Duplicate for seamless loop -->
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
      <img src="/assets/us_flag.png" alt="US Flag" class="flag-item">
      <img src="/assets/ukr.png" alt="Ukraine Flag" class="flag-item">
    </div>
  </div>

  <section class="video-section">
    <div class="container">
      <div class="video-wrapper">
        <video id="trumpVideo" controls playsinline preload="metadata" poster="/assets/cover.png" class="trump-video">
          <source src="/assets/trump.mp4" type="video/mp4">
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </section>


  <footer class="footer">
    <div class="container footer-content">
      <div class="footer-logo">$SOLENSKEE</div>
      <div class="footer-links">
        <a href="#">Home</a>
        <a href="#">Buy</a>
      </div>
      <div class="footer-social">
        <a href="#"><span>Twitter</span></a>
        <a href="#"><span>Telegram</span></a>
        <a href="#"><span>Discord</span></a>
      </div>
      <div class="footer-copyright">
        &copy; ${new Date().getFullYear()} $SOLENSKEE. All rights reserved. By CharacterGenerator
      </div>
    </div>
  </footer>
`;

// Copy contract address function
window.copyContractAddress = async () => {
  const contractAddress = document.getElementById('contractAddress').textContent;
  try {
    await navigator.clipboard.writeText(contractAddress);
    const copyBtn = document.querySelector('.copy-btn');
    copyBtn.textContent = 'COPIED!';
    setTimeout(() => {
      copyBtn.textContent = 'COPY';
    }, 2000);
  } catch (err) {
    console.error('Failed to copy:', err);
  }
};

// Set up Buy Now button URL based on PUMPFUN environment variable
const contractAddress = document.getElementById('contractAddress').textContent;
const buyNowBtn = document.getElementById('buyNowBtn');

// Set up Buy Now button URL based on PUMPFUN environment variable
if (PUMPFUN) {
  buyNowBtn.href = `https://pump.fun/coin/${CONTRACT_ADDRESS}`;
} else {
  buyNowBtn.href = `https://dexscreener.com/solana/${CONTRACT_ADDRESS}`;
}

// Handle sticky nav
const nav = document.getElementById('stickyNav');

window.addEventListener('scroll', () => {
  if (window.scrollY > 200) { // Show after scrolling 200px
    nav.classList.add('visible');
  } else { // At the top
    nav.classList.remove('visible');
  }
});

// Initialize animations
addRandomRotation();
addEmojiAnimation();

// Add hover effects to buttons
// Update footer content
document.querySelector('.footer').innerHTML = `
  <div class="container footer-content">
    <div class="footer-logo">$SOLENSKEE</div>
    <div class="footer-social">
      <a href="https://x.com/solenskee" target="_blank"><span>Twitter</span></a>
      <a href="https://t.me/solenskee" target="_blank"><span>Telegram</span></a>
    </div>
    <div class="footer-copyright">
      © ${new Date().getFullYear()} $SOLENSKEE. No comproomises! No rug! No capitulation!
    </div>
  </div>
`;

const buttons = document.querySelectorAll('.btn');
buttons.forEach(button => {
  button.addEventListener('mouseover', () => {
    button.style.transform = 'translateY(-5px) rotate(2deg)';
  });
  button.addEventListener('mouseout', () => {
    button.style.transform = 'translateY(0) rotate(-1deg)';
  });
});

